import React, { useState } from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { SectionHeading } from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import { ReactComponent as StarIcon } from "images/star-icon.svg";
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg-decorator-blob-5.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "images/svg-decorator-blob-7.svg";
import { Link } from "react-router-dom";
import af1 from "images/shop/af1.jpg";
import af2 from "images/shop/af2.jpg";
import af3 from "images/shop/af3.jpg";
import af4 from "images/shop/af4.jpg";
import af5 from "images/shop/af5.jpg";
import af6 from "images/shop/af6.jpg";
import af7 from "images/shop/af7.jpg";
import af8 from "images/shop/af8.jpg";
import af9 from "images/shop/af9.jpg";
import j11 from "images/shop/j11.jpg";
import j12 from "images/shop/j12.jpg";
import j13 from "images/shop/j13.jpg";
import j14 from "images/shop/j14.jpg";
import j15 from "images/shop/j15.jpg";
import j16 from "images/shop/j16.jpg";
import j17 from "images/shop/j17.jpg";
import j18 from "images/shop/j18.jpg";
import j41 from "images/shop/j41.jpg";
import j42 from "images/shop/j42.jpg";
import j43 from "images/shop/j43.jpg";
import j44 from "images/shop/j44.jpg";
import j45 from "images/shop/j45.jpg";
import j46 from "images/shop/j46.jpg";
import j47 from "images/shop/j47.jpg";
import j48 from "images/shop/j48.jpg";
import yeezy from "images/shop/yeezy.jpg";
import yeezy1 from "images/shop/yeezy1.jpg";
import yeezy2 from "images/shop/yeezy2.jpg";
import yeezy3 from "images/shop/yeezy3.jpg";
import yeezy4 from "images/shop/yeezy4.jpg";
import yeezy5 from "images/shop/yeezy5.jpg";
import yeezyh1 from "images/shop/yeezyh1.jpg";
import yeezyh2 from "images/shop/yeezyh2.jpg";
import foam1 from "images/shop/foam1.jpg";
import foam2 from "images/shop/foam2.jpg";
import foam3 from "images/shop/foam3.jpg";

const HeaderRow = tw.div`flex justify-between items-center flex-col xl:flex-row`;
const Header = tw(SectionHeading)``;
const TabsControl = tw.div`flex flex-wrap bg-black px-2 py-2 rounded leading-none mt-12 xl:mt-0`;

const TabControl = styled.div`
  ${tw`cursor-pointer px-6 py-3 mt-2 sm:mt-0 sm:mr-2 last:mr-0 text-gray-600 font-medium rounded-sm transition duration-300 text-sm sm:text-base w-1/2 sm:w-auto text-center`}
  &:hover {
    ${tw`bg-gray-500 text-gray-700`}
  }
  ${props => props.active && tw`bg-primary-500! text-gray-100!`}
  }
`;

const TabContent = tw(motion.div)`mt-6 flex flex-wrap sm:-mr-10 md:-mr-6 lg:-mr-12`;
const CardContainer = tw.div`mt-10 w-full sm:w-1/2 md:w-1/3 lg:w-1/4 sm:pr-10 md:pr-6 lg:pr-12`;
const Card = tw(motion.a)`bg-black rounded-b block max-w-xs mx-auto sm:max-w-none sm:mx-0`;
const CardImageContainer = styled.div`
  ${props => css`background-image: url("${props.imageSrc}");`}
  ${tw`h-56 xl:h-64 bg-center bg-cover relative rounded-t`}
`;
const CardRatingContainer = tw.div`leading-none absolute inline-flex bg-gray-100 bottom-0 left-0 ml-4 mb-4 rounded-full px-5 py-2 items-end`;
const CardRating = styled.div`
  ${tw`mr-1 text-sm font-bold flex items-end`}
  svg {
    ${tw`w-4 h-4 fill-current text-orange-400 mr-1`}
  }
`;

const CardHoverOverlay = styled(motion.div)`
  background-color: rgba(255, 255, 255, 0.5);
  ${tw`absolute inset-0 flex justify-center items-center`}
`;
const CardButton = tw(PrimaryButtonBase)`text-sm`;

const CardReview = tw.div`font-medium text-xs text-gray-600`;

const CardText = tw.div`p-4 text-gray-500`;
const CardTitle = tw.h5`text-lg font-semibold group-hover:text-primary-600`;
const CardContent = tw.p`mt-1 text-sm font-medium text-gray-500`;
const CardPrice = tw.p`mt-4 text-xl font-bold`;

const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none z-20 absolute right-0 top-0 h-64 w-64 opacity-15 transform translate-x-2/3 -translate-y-12 text-teal-100`}
`;
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
  ${tw`pointer-events-none z-20 absolute left-0 bottom-0 h-80 w-80 opacity-15 transform -translate-x-2/3 text-pink-900`}
`;

export default ({
  heading = "Welcome to the Marketplace",
  tabs = {
    Airforce: [
      {
        imageSrc: af1,
        title: "Airforce 1 hightops",
        content: "Black with coloured sole",
        price: "Kshs 2900",
        rating: "5.0",
        reviews: "87",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc:af2,
        title: "Airforce 1 hightops",
        content: "Split coloured",
        price: "Kshs 2900",
        rating: "4.8",
        reviews: "32",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc:af3,
        title: "Airforce 1",
        content: "Black suede airforce",
        price: "Kshs 2800",
        rating: "4.9",
        reviews: "89",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: af4,
        title: "Airforce 1",
        content: "Plain white airforce",
        price: "Kshs 2200",
        rating: "4.6",
        reviews: "12",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: af5,
        title: "Airforce 1",
        content: "Plain white with chunky laces",
        price: "Kshs 2400",
        rating: "4.2",
        reviews: "19",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: af6,
        title: "Airforce 1",
        content: "Airforce hightops",
        price: "2600",
        rating: "4.9",
        reviews: "61",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: af7,
        title: "Airforce 1",
        content: "White suede airforce",
        price: "$Kshs 3000",
        rating: "4.9",
        reviews: "55",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: af8,
        title: "Airforce 1",
        content: "Plain black airforce",
        price: "Kshs 2200",
        rating: "4.9",
        reviews: "81",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: af9,
        title: "Airforce 1",
        content: "Multi-coloured airforce",
        price: "Kshs 2700",
        rating: "4.9",
        reviews: "6",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
    ],
    Jordan1s: [
      {
        imageSrc: j11,
        title: "Jordan 1s",
        content: "Dior brown and white",
        price: "Kshs 2900",
        rating: "5.0",
        reviews: "87",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc:j12,
        title: "Jordan 1s",
        content: "Dior black and gray",
        price: "Kshs 2900",
        rating: "4.8",
        reviews: "32",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: j13,
        title: "Jordan 1s",
        content: "Dior blue and white",
        price: "Kshs 2900",
        rating: "4.9",
        reviews: "89",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: j14,
        title: "Jordan 1s",
        content: "Dior black and brown",
        price: "Kshs 2900",
        rating: "4.6",
        reviews: "12",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc:j15,
        title: "Jordan 1s",
        content: "White,gray and black",
        price: "Kshs 2800",
        rating: "5.0",
        reviews: "19",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: j16,
        title: "Jordan 1s",
        content: "Red,white and black",
        price: "Kshs 2800",
        rating: "5.0",
        reviews: "61",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: j17,
        title: "Jordan 1s",
        content: "Cloud blue",
        price: "Kshs 2800",
        rating: "5.0",
        reviews: "56",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: j18,
        title: "Jordan 1s",
        content: "Blue colorway",
        price: "Kshs 2800",
        rating: "5.0",
        reviews: "37",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
    ],
    Jordan4s: [
      {
        imageSrc: j41,
        title: "Jordan 4s",
        content: "Black",
        price: "Kshs 3100",
        rating: "5.0",
        reviews: "78",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc:j42,
        title: "Jordan 4s",
        content: "Gray with green",
        price: "Kshs Kshs 3100",
        rating: "4.8",
        reviews: "32",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: j43,
        title: "Jordan 4s",
        content: "Gray with black",
        price: "Kshs 3100",
        rating: "4.9",
        reviews: "89",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: j44,
        title: "Jordan 4s",
        content: "White, maroon and black",
        price: "Kshs 3100",
        rating: "4.6",
        reviews: "12",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: j45,
        title: "Jordan 4s",
        content: "Black with red",
        price: "Kshs 3100",
        rating: "4.2",
        reviews: "19",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: j46,
        title: "Jordan 4s",
        content: "Black with yellow",
        price: "Kshs 3100",
        rating: "5.0",
        reviews: "61",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: j47,
        title: "Jordan 4s",
        content: "White, red and black",
        price: "Kshs 3100",
        rating: "5.0",
        reviews: "61",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: j48,
        title: "Jordan 4s",
        content: "Gray",
        price: "Kshs 3100",
        rating: "5.0",
        reviews: "61",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
    ],
    Yeezys: [
      {
        imageSrc: yeezy,
        title: "Yeezy 450",
        content: "Low-cut black",
        price: "Kshs 2600",
        rating: "5.0",
        reviews: "87",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: yeezy1,
        title: "Yeezy slides",
        content: "Pink",
        price: "Kshs 1900",
        rating: "5.0",
        reviews: "92",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: yeezy2,
        title: "Yeezy slides",
        content: "Green",
        price: "Kshs 1900",
        rating: "5.0",
        reviews: "32",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: yeezy3,
        title: "Yeezy slides",
        content: "Orange",
        price: "Kshs 1900",
        rating: "5.0",
        reviews: "58",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: yeezy4,
        title: "Yeezy slides",
        content: "Black",
        price: "Kshs 1900",
        rating: "5.0",
        reviews: "63",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: yeezy5,
        title: "Yeezy slides",
        content: "White",
        price: "$Kshs 1900",
        rating: "5.0",
        reviews: "87",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: yeezyh1,
        title: "Yeezy Hightops",
        content: "Gray 450",
        price: "Kshs 2700",
        rating: "5.0",
        reviews: "22",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: yeezyh2,
        title: "Yeezy Hightops",
        content: "Black 450",
        price: "Kshs 2700",
        rating: "5.0",
        reviews: "90",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: foam1,
        title: "Foam Slippers",
        content: "White",
        price: "Kshs 1900",
        rating: "5.0",
        reviews: "43",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: foam2,
        title: "Foam Slippers",
        content: "Pink",
        price: "Kshs 1900",
        rating: "5.0",
        reviews: "27",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
      {
        imageSrc: foam3,
        title: "Foam Slippers",
        content: "Black",
        price: "Kshs 1900",
        rating: "5.0",
        reviews: "102",
        url: "https://forms.gle/6Mnn95mZiU1nJhfD6"
      },
    ],
  }
}) => {
  /*
   * To customize the tabs, pass in data using the `tabs` prop. It should be an object which contains the name of the tab
   * as the key and value of the key will be its content (as an array of objects).
   * To see what attributes are configurable of each object inside this array see the example above for "Starters".
   */
  const tabsKeys = Object.keys(tabs);
  const [activeTab, setActiveTab] = useState(tabsKeys[0]);

  return (
    <Container>
      <ContentWithPaddingXl>
        <HeaderRow>
          <Header>{heading}</Header>
          <TabsControl>
            {Object.keys(tabs).map((tabName, index) => (
              <TabControl key={index} active={activeTab === tabName} onClick={() => setActiveTab(tabName)}>
                {tabName}
              </TabControl>
            ))}
          </TabsControl>
        </HeaderRow>

        {tabsKeys.map((tabKey, index) => (
          <TabContent
            key={index}
            variants={{
              current: {
                opacity: 1,
                scale:1,
                display: "flex",
              },
              hidden: {
                opacity: 0,
                scale:0.8,
                display: "none",
              }
            }}
            transition={{ duration: 0.4 }}
            initial={activeTab === tabKey ? "current" : "hidden"}
            animate={activeTab === tabKey ? "current" : "hidden"}
          >
            {tabs[tabKey].map((card, index) => (
              <CardContainer key={index}>
                <Card className="group" href={card.url} initial="rest" whileHover="hover" animate="rest">
                  <CardImageContainer imageSrc={card.imageSrc}>
                    <CardRatingContainer>
                      <CardRating>
                        <StarIcon />
                        {card.rating}
                      </CardRating>
                      <CardReview>({card.reviews})</CardReview>
                    </CardRatingContainer>
                    <CardHoverOverlay
                      variants={{
                        hover: {
                          opacity: 1,
                          height: "auto"
                        },
                        rest: {
                          opacity: 0,
                          height: 0
                        }
                      }}
                      transition={{ duration: 0.3 }}
                    >
                      <CardButton><Link to ="/Order Form">Buy Now</Link></CardButton>
                    </CardHoverOverlay>
                  </CardImageContainer>
                  <CardText>
                    <CardTitle>{card.title}</CardTitle>
                    <CardContent>{card.content}</CardContent>
                    <CardPrice>{card.price}</CardPrice>
                  </CardText>
                </Card>
              </CardContainer>
            ))}
          </TabContent>
        ))}
      </ContentWithPaddingXl>
      <DecoratorBlob1 />
      <DecoratorBlob2 />
    </Container>
  );
};